import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    marginBottom: '150px'
  },
  header: {
    marginBottom: theme.spacing(10)
  },
  floatingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'auto',
    position: 'fixed',
    left: 0,
    width: '100%',
    bottom: 0,
    zIndex: 99,
    background: theme.colorPalette.beige_50,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)'
  },
  footerContainer: {
    height: 98,
    display: 'flex',
    width: '100%',
    maxWidth: 1200,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  saveButton: {
    width: 244
  }
});

export default makeStyles(styles);
